import pageContext from 'salvo-lite/context'
import ChangeClass from './components/ChangeClass'
import Select from './components/Select'
import Slick from './components/Slick'
import Preload from './components/Preload'
import Sticky from './components/Sticky'
import MobileMenu from './components/MobileMenu'
import Slide from './components/Slide'
import ChangeClassOnScroll from './components/ChangeClassOnScroll'
import GEOIP from './components/GEOIP'
import Lightbox from './components/Lightbox'
import InitAOS from './components/InitAOS'
import FilterAndSort from './components/FilterAndSort'
import MobileChangeClass from './components/MobileChangeClass'
import ProductForm from './components/ProductForm'
import Cart from './components/Cart'
import BlogFilter from './components/BlogFilter'
import Accordion from './components/Accordion'
import FAQSearch from './components/FAQSearch'
import ProductImages from './components/ProductImages'
import Search from './components/Search'
import QuickBuy from './components/QuickBuy'
import DropdownMenu from './components/DropdownMenu'
import VideoContainer from './components/VideoContainer'
import ContactForm from './components/ContactForm'
import SizeGuideScroller from './components/SizeGuideScroller'
import Zoom from './components/Zoom'
import ProductRecommendations from './components/ProductRecommendations'
import Addresses from './pages/Addresses'
import Login from './pages/Login'
import SectionUnderHeader from './components/SectionUnderHeader'
import QuickView from './components/QuickView'

const components = {
    'change-class': ChangeClass,
    'select': Select,
    'slick': Slick,
    'preloader': Preload,
    'sticky': Sticky,
    'mobile-menu': MobileMenu,
    'slide': Slide,
    'change-class-on-scroll': ChangeClassOnScroll,
    'section-under-header': SectionUnderHeader,
    'geoip-switcher': GEOIP,
    'lightbox': Lightbox,
    'init-aos': InitAOS,
    'filter-and-sort': FilterAndSort,
    'mobile-class': MobileChangeClass,
    'product-form': ProductForm,
    'cart': Cart,
    'blog-filter': BlogFilter,
    'accordion': Accordion,
    'faq-search': FAQSearch,
    'product-images': ProductImages,
    'search': Search,
    'quick-buy': QuickBuy,
    'dropdown-menu': DropdownMenu,
    'video-container': VideoContainer,
    'contact-form': ContactForm,
    'size-guide-scroller': SizeGuideScroller,
    'zoom': Zoom,
    'product-recommendations': ProductRecommendations,
    'quick-view': QuickView
}

const pages = {
    'customers/addresses': Addresses,
    'customers/login': Login
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents (container = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = container.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js